import { AppRoutes } from '@core-types/app-routes.type';
import { PLANOGRAM_ROUTES } from '@pages/planograms/planograms.routes';

export const routes: AppRoutes = [
  {
    path: '',
    redirectTo: 'planograms',
    pathMatch: 'full',
  },
  {
    path: 'planograms',
    children: PLANOGRAM_ROUTES,
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
